import{createContext}from"react";export var focusScope=createContext(void 0);